module.exports = __webpack_public_path__ + "img/qrcode_android_googleplay.cc751c50.png";